import React from 'react';
import AppRoute from './AppRoute';
import Loader from '../helper/loaders';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { errorLayout } from '../layouts/ErrorLayout';
import PublicLayout from '../layouts/PublicLayout/PublicLayout';
import { Route, withRouter } from 'react-router';
import WelcomePage from '../components/Welcome';
import AuthRoutes from '../routes/NestedRoutes/AuthRoutes';
import ProductsRoutes from '../routes/NestedRoutes/ProductsRoutes';
import ActivitiesRoutes from '../routes/NestedRoutes/ActivitiesRoutes';
import LegalRoutes from '../routes/NestedRoutes/LegalRoutes';
import AdminRoutes from '../routes/NestedRoutes/AdminRoutes';
const NotFoundPage = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../containers/not-found-page.component')
);

const Routers = () => {

    return (
        <Router>
            <Switch>

                <AppRoute
                    exact={true}
                    path='/'
                    component={WelcomePage}
                    layout={PublicLayout}
                    type='public'
                    title='Welcome'
                />

                <Route
                    path='/auth'
                    component={AuthRoutes}
                />

                <Route
                    path='/products'
                    component={ProductsRoutes}
                />

                <Route
                    path='/activities'
                    component={ActivitiesRoutes}
                />

                <Route
                    path='/legals'
                    component={LegalRoutes}
                />
                <Route
                    path='/admin'
                    component={AdminRoutes}
                />

                <AppRoute
                    exact
                    path='*'
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

            </Switch>
        </Router>
    )
};

export default withRouter(Routers);